import { call, put, takeLatest, select } from 'redux-saga/effects';
import * as Actions from './hold-requests-actions';
import * as Apis from '../../apis';

export function* getHoldRequestsList(request) {
  try {
    const holdRequests = yield call(Apis.getHoldRequests, request.payload);
    yield put(Actions.getHoldRequestsListSuccess(holdRequests));
  } catch (error) {
    yield put(Actions.getHoldRequestsListFailure(error));
  }
}

export function* watchGetPoItemHoldRequestsSaga() {
  yield takeLatest(Actions.HOLD_REQUESTS_LIST_ACTIONS.REQUEST, getHoldRequestsList);
}
